module.exports = __webpack_public_path__ + "static/img/dps02.d9372765.png";